import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class UserResolver implements Resolve<Promise<any>> {
  constructor(private authService: AuthService) {}

  resolve(): Promise<any> {
    return this.authService.getUser();
  }
}
